export default function interlockReducer(state={
    categoriesList: [],
    fetching: false,
    fetched: false,
    error: null,
}, action) {

    switch( action.type ) {
        case "FETCH_INTERLOCKS":
            return { ...state, fetching: true };

        case "FETCH_INTERLOCKS_REJECTED":
            return {
                ...state,
                fetching: false,
                error: action.payload
            };

        case "FETCH_INTERLOCKS_FULFILLED":
            const interlocks = action.payload.interlocks.sort(function (a, b) {
                return a.interlockName.localeCompare(b.interlockName, 'en', {sensitivity: 'base'})
            });
            return {
                ...state,
                fetching: false,
                fetched: true,
                interlockList: interlocks.map((c) => ({
                    ...c,
                    getId: () => c.interlockId
                }))
            };

        default:
            return state;

    }
}



// WEBPACK FOOTER //
// ./app/reducers/timeInput/interlock.js